import React from "react";
import "./highlights.css";
import { FaList } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

// Product Card Component
const ProductCard = ({ product, onFeaturedClick }) => {
  const {
    title,
    sub_title,
    type,
    button_text,
    images,
    theme,
    main_img,
    sec_img,
  } = product;

  const navigate = useNavigate();

  if (type === "featured") {
    return (
      <div className={`product-card-high featured-card ${theme || "light"}`}>
        <div className="product-content">
          <div className="product-info">
            <h2 className="product-title">{title}</h2>
            <p className="product-subtitle">{sub_title}</p>
            {button_text && (
              <button
                className="shop-button"
                onClick={() => {
                  const navState = {
                    category: product.category || product.tag,
                    title: product.title,
                  };

                  console.log(
                    "Navigating to ProductLayout with state:",
                    navState,
                  );

                  navigate("/ProductLayout", {
                    state: navState,
                  });
                }}
              >
                {button_text}
              </button>
            )}
          </div>

          <div
            onClick={() =>
              onFeaturedClick(product.category || product.tag, product.title)
            }
            className="product-image-container"
          >
            {(main_img || images?.main_img) && (
              <img
                src={main_img || images?.main_img}
                alt={title}
                className="product-image main-image"
              />
            )}
            {(sec_img || images?.sec_img) && (
              <div className="secondary-image-container">
                <img
                  src={sec_img || images?.sec_img}
                  alt={`${title} Box`}
                  className="secondary-image"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

// Skeleton Loader Card
const SkeletonCard = () => (
  <div className="product-card-high featured-card">
    <div className="product-content">
      <div className="product-info">
        <Skeleton height={40} width={200} />
        <Skeleton height={20} width={150} style={{ marginTop: 10 }} />
        <Skeleton height={40} width={120} style={{ marginTop: 20 }} />
      </div>
      <div className="product-image-container">
        <Skeleton height={300} width={400} />
        <div className="secondary-image-container">
          <Skeleton height={150} width={150} />
        </div>
      </div>
    </div>
  </div>
);

// Highlighted Products Component
const HighLightedProducts = ({
  products = [],
  onFeaturedClick,
  highloader,
}) => {
  const navigate = useNavigate();

  if (highloader) {
    return (
      <div className="product-highlight-container">
        <SkeletonCard />
      </div>
    );
  }

  if (!products.length) return null;

  const featured = products.filter((p) => p.type === "featured");

  return (
    <div className="product-highlight-container">
      <button
        className="close-button-back"
        onClick={() => navigate("/ProductLayout")}
      >
        <span className="button-icon">
          <FaList />
        </span>
        <span className="button-text">show all</span>
      </button>

      {/* ONLY CHANGE: limit to 2 cards */}
      {featured.slice(0, 2).map((product) => (
        <React.Fragment key={product.id}>
          <ProductCard product={product} onFeaturedClick={onFeaturedClick} />
        </React.Fragment>
      ))}
    </div>
  );
};

export default HighLightedProducts;
